import { render, staticRenderFns } from "./QueueAdd.vue?vue&type=template&id=2095a4c6"
import script from "./QueueAdd.vue?vue&type=script&lang=ts"
export * from "./QueueAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports